import React, { useState } from 'react'
import { Button } from 'react-angle-dashboard-components'
import RangeSlider from 'react-bootstrap-range-slider'
import styled from 'styled-components'

const RangeSliderWrapper = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 530px;
  height: 250px;
  z-index: 99999;
  padding: 52px;
  border-radius: 6px;
  box-shadow: 0px 0px 7px -1px #000000;
`

const ContinueButton = styled(Button)`
  color: #fff;
  width: 375px;
  height: 46px;
  font-size: 18px;
`
interface AgeSliderProps {
  value: number
  setValue: Function
  continueCallback: Function
  style: any
}

const Comp = (props: AgeSliderProps, ref: any) => {
  const [value, setValue] = useState<number>(props.value)
  return (
    <RangeSliderWrapper ref={ref} style={props.style}>
      <h1 className="text-primary fs-32 mb-6">Your Average Employee Age</h1>
      <div className="w-100 mb-3">
        <RangeSlider
          min={20}
          max={80}
          tooltip="on"
          tooltipPlacement="bottom"
          value={value}
          variant="secondary"
          tooltipLabel={(currentValue) => value}
          onChange={(e) => {
            setValue(+e.target.value)
            props.setValue(+e.target.value)
          }}
        />
      </div>
      <ContinueButton
        className="mt-4"
        variant="primary"
        onClick={() => props.continueCallback(value)}
      >
        Continue
      </ContinueButton>
    </RangeSliderWrapper>
  )
}

export const AgeSlider = React.forwardRef(Comp)

export default AgeSlider
